import { OrderValuesContext } from '@src/orders/OrderValuesContext';
import { useContext } from 'react';

export const useOrderValuesContext = () => {
  const context = useContext(OrderValuesContext);

  if (!context) {
    throw new Error('Can not use context without provider');
  }

  return context;
};
